module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAAAhCAYAAAAxvj44AAAACXBIWXMAABcRAAAXEQHKJvM/AAAA/UlEQVRoge3byw3CQAxF0RcqoAR6yBRAJ6QFOqIU2M8ipYQKgoIiFH4hmbHHRnpX8t7yWbvq+x6WhRC2McbOdIk/aGO5YgjhBOA8YP3LwawygxqRDgB247CZTKAmSFcA+xhjS6T5ikMRKa2iUERKrxgUkfIqAkWk/NShiCSTKhSR5FKDIpJsKlBEkk8cikg6iUIRSS8xKCLpJgJFJP2yoYhUpiwoIpUrGYpIZUuCIlL5VkMRyaZVUESyazEUkWxbBEUk+35CEclHs1BE8tNXKCL56iMUkfz1BkUknz1BEclvj2+OCdLQEQCR/NTdoV6QmL8uVV3XDYCGOI4D2hsrz7wKLJd/oAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/jiantou2.png
// module id = W3OQ
// module chunks = 1